import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ActionItemComponent } from '../shared/action-item.component';
import { ProfileMenuComponent } from '../shared/profile-menu.component';

@Component({
  selector: 'oc-bar',
  standalone: true,
  imports: [CommonModule, RouterModule, ActionItemComponent, ProfileMenuComponent],
  template: `
    <div class="oc-bar d-flex justify-content-between">
      <img class="oc-bar-branding" src="/logo-1.svg" />
      <div class="oc-bar-options d-flex align-items-center gap-1">
        <!-- <oc-action-item icon="tablerSearch"></oc-action-item>
        <oc-action-item icon="tablerBell">></oc-action-item> -->
        <oc-profile-menu><oc-action-item icon="tablerUserCircle" [invert]="true"></oc-action-item></oc-profile-menu>
      </div>
    </div>
  `,
  styles: `
    .oc-bar {
      height: 60px;
      z-index: 1;
      background: var(--bs-primary);
      box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.3);
      position: fixed;
      width: 100%;
    }

    .oc-bar-branding {
      margin-left: 1.2rem;
      height: 54px;
      margin-block: auto;
    }

    .oc-bar-options {
      padding: 0 1.2rem;
    }
  `,
})
export class BarComponent {}
